import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueGtm from 'vue-gtm';
Vue.use(VueGtm, {
  id: 'GTM-T5MBRV',
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});
// import DisableAutocomplete from 'vue-disable-autocomplete';
// Vue.use(DisableAutocomplete);
import store from './store/index';
import '@/components/inputs/_globals';
import VueMobileDetection from 'vue-mobile-detection';
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);
Vue.use(VueMobileDetection);
import VeeValidate, { Validator } from 'vee-validate';
import da from 'vee-validate/dist/locale/da';
Validator.localize({
  da: da,
});
Vue.use(VeeValidate, {
  events: 'input|change',
  locale: 'da',
});
Vue.config.productionTip = false;

import Autocomplete from 'v-autocomplete';
Vue.use(Autocomplete);

import { ModalPlugin } from 'bootstrap-vue';
Vue.use(ModalPlugin);

// import VueAnalytics from 'vue-analytics'
// Vue.use(VueAnalytics, {
//   // id: store.state.pageData.GAnalyticsId,
//   id: "UA-2212565-4",
//   debug: {
//     sendHitTask: process.env.NODE_ENV === 'production',
//     sendHitTask : true,
//     enabled: true, // default value
//   }
// })

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
